module.exports = __webpack_public_path__ + "img/card1.8f0c2371.png";